import React from 'react';
import PropTypes from 'prop-types';

import styles from 'styles/components/gigSetup/Container.module.scss';

const AdditionalInfo = ({ shoutoutText, shoutoutEg, brandEg, brandText, margin }) => (
  <div className={styles.additionalInfo} style={{ margin: margin || {} }}>
    <div>
      <strong className="color-main">For Shoutouts:</strong>{' '}
      <span style={shoutoutEg ? { fontWeight: 'bold' } : {}}>{shoutoutText}</span>
      {shoutoutEg && (
        <>
          <br />
          <i style={{ display: 'block', marginTop: 5 }}>{shoutoutEg}</i>
        </>
      )}
    </div>

    <div>
      <strong className="color-main">For Brands:</strong>{' '}
      <span style={shoutoutEg ? { fontWeight: 'bold' } : {}}>{brandText}</span>
      {brandEg && (
        <>
          <br />
          <i style={{ display: 'block', marginTop: 5 }}>{brandEg}</i>
        </>
      )}
    </div>
  </div>
);

AdditionalInfo.propTypes = {
  shoutoutText: PropTypes.string,
  shoutoutEg: PropTypes.string,
  brandEg: PropTypes.string,
  brandText: PropTypes.string,
  margin: PropTypes.string,
};

AdditionalInfo.defaultProps = {
  shoutoutText: '',
  shoutoutEg: '',
  brandEg: '',
  brandText: '',
  margin: '',
};

export default AdditionalInfo;
